import {
  ViewGridIcon,
  CursorClickIcon,
  DocumentTextIcon,
  StarIcon,
  HomeIcon,
  ViewBoardsIcon,
  BellIcon,
  LocationMarkerIcon,
  UserIcon,
  ColorSwatchIcon
} from '@heroicons/vue/outline'
import { createRouter, createWebHashHistory } from 'vue-router'
import {
  CreditCardIcon,
} from '@heroicons/vue/solid'

const Login = () => import('@/modules/auth/views/login.vue')
const DeleteAccount = () => import('@/modules/auth/views/delete-account.vue')
const Register = () => import('@/modules/auth/views/register.vue')
const ForgotPassword = () => import('@/modules/auth/views/forgot-password.vue')
const NotFound = () => import('@/modules/pages/views/404.vue')
const Dashboard = () => import('@/modules/dashboard/views/index.vue')
const Table = () => import('@/modules/table/views/index.vue')
const Grid = () => import('@/modules/grid/views/index.vue')
const Notification = () => import('@/modules/notification/views/index.vue')
const Button = () => import('@/modules/buttons/views/index.vue')
const Tags = () => import('@/modules/tags/views/index.vue')
const Typography = () => import('@/modules/typography/views/index.vue')
const Card = () => import('@/modules/cards/views/index.vue')
const Icons = () => import('@/modules/icons/views/index.vue')
const Profile = () => import('@/modules/profile/views/index.vue')
const ProfileDetail = () => import('@/modules/auth/views/profile.vue')
const ProfileCustomSettings = () => import('@/modules/auth/views/custom-settings.vue')
const Map = () => import('@/modules/map/views/index.vue')
const Devices = () => import('@/modules/devices/views/index.vue')
const Admin = () => import('@/modules/administration/views/index.vue')
const BackOffice = () => import('@/modules/back-office/views/index.vue')
const BackOfficeDistributorList = () => import('@/modules/back-office/views/distributors/distributor.vue')
const Equipment = () => import('@/modules/equipment/views/index.vue')
const Other_dash = () => import('@/modules/other_dash/views/index.vue')
const ErrorReport = () => import('@/modules/devices/views/error-report.vue')
const Document = () => import('@/modules/devices/views/document.vue')
const Device_details = () => import('@/modules/devices/views/detail.vue')
const ReportMessage = () => import('@/modules/devices/views/report.vue')
const MachineMessage = () => import('@/modules/devices/views/machine_message.vue')
const LastFieldReportMessage = () => import('@/modules/devices/views/last-field-report.vue')
const ServicesMessage = () => import('@/modules/devices/views/services-message.vue')
const ProductDetails = () => import('@/modules/equipment/views/details.vue')
const ProductFirmware = () => import('@/modules/administration/views/equipment/product-firmware.vue')
const ProductDocument = () => import('@/modules/administration/views/equipment/product-document.vue')
const VideoManagement = () => import('@/modules/administration/views/equipment/video-management.vue')
const AdminProduct = () => import('@/modules/administration/views/equipment/product.vue')
const AdminModel = () => import('@/modules/administration/views/equipment/model.vue')
const AdminBrand = () => import('@/modules/administration/views/equipment/brand.vue')
const AdminCategory = () => import('@/modules/administration/views/equipment/category.vue')
const AdminSubcategory = () => import('@/modules/administration/views/equipment/subcategory.vue')
const AdminUser = () => import('@/modules/administration/views/user/user.vue')
const AdminGroup = () => import('@/modules/administration/views/user/group.vue')
const AdminPendingErrorRules = () => import('@/modules/administration/views/site/pending-error-rules.vue')
const AdminGroupPermission = () => import('@/modules/administration/views/user/group-permission.vue')
const AdminHistory = () => import('@/modules/administration/views/device/history.vue')
const AdminTroubleshootingStatitics = () => import('@/modules/administration/views/device/equipment-usage.vue')
const ErrorsMessage = () => import('@/modules/devices/views/errors-message.vue')
const AlertsMessage = () => import('@/modules/devices/views/alerts-message.vue')
const MaintenanceMessage = () => import('@/modules/devices/views/maintenance.vue')
const AdminMaintenanceSetting = () => import('modules/administration/views/maintenance/setting.vue')
const AdminMaintenanceProduct = () => import('modules/administration/views/maintenance/product.vue')
const PrivacyPolicy = () => import('@/modules/other_dash/views/privacy-policy.vue')

const QrCodeDocumentation = () => import('@/modules/other_dash/views/qr-code-documentation.vue')

const Test = () => import('components/Calibration/TestWB.vue')

const ComponentLayout = () => import('@/components/ComponentLayout/index.vue')
const DeviceDocumentPublic = () => import('@/modules/other_dash/views/device-document-public.vue')


const routes = [
  {
    path: '/',
    name: 'RootHandler',
    component: DeviceDocumentPublic,
    meta: {
      title: 'Home',
      requiresAuth: false,
      type: 'all'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      const allowedDocsDomains = ['stage.documentation.tssinfohub.com', 'documentation.tssinfohub.com']
      const isDocumentation = allowedDocsDomains.includes(window.location.hostname)
      if (isDocumentation) {
        next()
      } else {
        next('/dashboard')
      }
    }
  },
  {
    path: '/pippo',
    component: Test,
    name: 'Pippo',
    meta: {
      title: 'Pippo',
      icon: HomeIcon,
      color: 'text-indigo-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'all'
    },
  },
  {
    path: '/components/:componentItem?',
    component: ComponentLayout,
    name: 'Components',
    meta: {
      title: 'Components',
      icon: ColorSwatchIcon,
      color: 'text-info',
      requiresAuth: true,
      parentPath: 'Components'
    },
    children: [
      {
        path: 'buttons',
        name: 'Buttons',
        component: Button,
        meta: {
          title: 'Buttons',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'tags',
        name: 'Tags',
        component: Tags,
        meta: {
          title: 'Tags',
          icon: CursorClickIcon,
          color: 'text-primary',
          requiresAuth: true,
        },
      },
      {
        path: 'notifications',
        component: Notification,
        name: 'Notifications',
        meta: {
          title: 'Notifications',
          icon: BellIcon,
          color: 'text-success-50',
          requiresAuth: true,
        },
      },
      {
        path: 'tables',
        component: Table,
        name: 'Tables',
        meta: {
          title: 'Tables',
          icon: ViewBoardsIcon,
          color: 'text-indigo-410',
          requiresAuth: true,
        },
      },
      {
        path: 'grid',
        component: Grid,
        name: 'Grid',
        meta: {
          title: 'Grid',
          icon: ViewGridIcon,
          color: 'text-info',
          requiresAuth: true,
        },
      },
      {
        path: 'typography',
        component: Typography,
        name: 'Typography',
        meta: {
          title: 'Typography',
          icon: DocumentTextIcon,
          color: 'text-yellow-310',
          requiresAuth: true,
        },
      },
      {
        path: 'cards',
        component: Card,
        name: 'Cards',
        meta: {
          title: 'Cards',
          icon: CreditCardIcon,
          color: 'text-warning-50',
          requiresAuth: true,
        },
      },
      {
        path: 'icons',
        component: Icons,
        name: 'Icons',
        meta: {
          title: 'Icons',
          icon: StarIcon,
          color: 'text-red-410',
          requiresAuth: true,
        },
      },
    ]
  },

  {
    path: '/profile',
    component: Profile,
    name: 'Profile',
    meta: {
      title: 'Profile',
      icon: UserIcon,
      color: 'text-success-50',
      isDarkBackground: true,
      isFullWidthLayout: true,
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/map',
    component: Map,
    name: 'Map',
    meta: {
      title: 'Map',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/register',
    component: Register,
    name: 'register',
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'forgot-password',
    meta: {
      requiresAuth: false,
    },
  },
  {

    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/auth/delete-account',
    component: DeleteAccount,
    name: 'delete-account',
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound',
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: Devices,
    name: 'Devices',
    meta: {
      title: 'Devices',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'all'
    },
  },
  {
    path: '/device-wheel-balancer-list',
    component: Devices,
    name: 'Wheel Balancer',
    meta: {
      title: 'Wheel Balancer',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'wheel'
    },
  },
  {
    path: '/device-tire-changer-list',
    component: Devices,
    name: 'Tire Changer',
    meta: {
      title: 'Tire Changer',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'tyre'
    },
  },
  {
    path: '/product-tire-changer-list',
    component: Equipment,
    name: 'Product Tire Changer',
    meta: {
      title: 'Tire Changer',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'tyre'
    },
  },
  {
    path: '/product-wheel-balancer-list',
    component: Equipment,
    name: 'Product Wheel Balancer',
    meta: {
      title: 'Wheel Balancer',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'wheel'
    },
  },
  {
    path: '/field-reports',
    component: Other_dash,
    name: 'Field Reports',
    meta: {
      title: 'Field Reports',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'reports'
    },
  },
  {
    path: '/eula',
    component: Other_dash,
    name: 'EULA',
    meta: {
      title: 'EULA',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'eula'
    },
  },
  {
    path: '/privacy',
    component: Other_dash,
    name: 'Privacy',
    meta: {
      title: 'Privacy',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'privacy'
    },
  },
  {
    path: '/cookies_setting',
    component: Other_dash,
    name: 'Cookies Setting',
    meta: {
      title: 'Cookies Setting',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'cookies'
    },
  },
  {
    path: '/contact',
    component: Other_dash,
    name: 'Contact',
    meta: {
      title: 'Contact',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home',
      type: 'contacts'
    },
  },
  {
    path: '/back-office',
    component: BackOffice,
    name: 'Back Office',
    meta: {
      title: 'Back Office',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/back-office',
    component: BackOffice,
    name: 'Distributor',
    meta: {
      title: 'Distributor',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'dealer-list',
        name: 'Dealer Device Assignments',
        component: BackOfficeDistributorList,
        meta: {
          title: 'Device Assignments',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
          type: 'back-office',
        },
      },
    ],
  },
  
  {
    path: '/dealer',
    component: BackOffice,
    name: 'Dealer',
    meta: {
      title: 'Dealer',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/dealer',
    component: BackOffice,
    name: 'Shop Owner',
    meta: {
      title: 'Shop Owner',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'shop-owner-list',
        name: 'Shop Owner Device Assignments',
        component: BackOfficeDistributorList,
        meta: {
          title: 'Device Assignments',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
          type: 'dealer',
        },
      },
    ],
  },
  {
    path: '/administration',
    component: Admin,
    name: 'Administration',
    meta: {
      title: 'Administration',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/privacy-cookie-policy',
    component: PrivacyPolicy,
    name: 'Privacy Cookie Policy',
    meta: {
      title: 'Privacy Cookie Policy',
      icon: CursorClickIcon,
      color: 'text-red-410',
      requiresAuth: false,
      parentPath: 'Home'
    },
  },

  {
    path: '/administration',
    component: Admin,
    name: 'Site',
    meta: {
      title: 'Site',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'product-language-list',
        name: 'Languages',
        component: Admin,
        meta: {
          title: 'Languages',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'archive-product-document-type-list',
        name: 'Document Types',
        component: Admin,
        meta: {
          title: 'Document Types',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-geek-dictionary-list',
        name: 'Values',
        component: Admin,
        meta: {
          title: 'Values',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-page-name-list',
        name: 'Page Names',
        component: Admin,
        meta: {
          title: 'Page Names',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'pending-error-rules-list',
        name: 'Pending Error Rules',
        component: AdminPendingErrorRules,
        meta: {
          title: 'Pending Error Rules',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'troubleshooting-error-dictionary-list',
        name: 'Error Dictionary',
        component: Admin,
        meta: {
          title: 'Error Dictionary',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'troubleshooting-error-dictionary-upload-csv-list',
        name: 'Error Dictionary Upload',
        component: Admin,
        meta: {
          title: 'Error Dictionary Upload',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'message-from-client-list',
        name: 'Message from Customers',
        component: Admin,
        meta: {
          title: 'Message from Customers',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'message-to-client-list',
        name: 'Message to Customers',
        component: PrivacyPolicy,
        meta: {
          title: 'Message to Customers',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/administration',
    component: Admin,
    name: 'Account',
    meta: {
      title: 'Account',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'account-user-list',
        name: 'Users',
        component: AdminUser,
        meta: {
          title: 'Users',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'account-group-list',
        name: 'Groups',
        component: AdminGroup,
        meta: {
          title: 'Groups',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'account-group-iot-permissions-list',
        name: 'Group App Permissions',
        component: AdminGroupPermission,
        meta: {
          title: 'Group App Permissions',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      }
    ],
  },
  {
    path: '/administration',
    component: Admin,
    name: 'Equipment',
    meta: {
      title: 'Equipment',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'product-category-list',
        name: 'Categories',
        component: AdminCategory,
        meta: {
          title: 'Categories',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-subcategory-list',
        name: 'Subcategories',
        component: AdminSubcategory,
        meta: {
          title: 'Subcategories',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-brand-list',
        name: 'Brand',
        component: AdminBrand,
        meta: {
          title: 'Brand',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-model-list',
        name: 'Models',
        component: AdminModel,
        meta: {
          title: 'Models',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-product-list',
        name: 'Product all',
        component: AdminProduct,
        meta: {
          title: 'Equipment',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'archive-product-firmware-list',
        name: 'Software',
        component: ProductFirmware,
        meta: {
          title: 'Software',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'archive-product-document-list',
        name: 'Documentation Management',
        component: ProductDocument,
        meta: {
          title: 'Documentation Management',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'product-video-list',
        name: 'Video Management',
        component: VideoManagement,
        meta: {
          title: 'Video Management',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      }
    ],
  },
  {
    path: '/administration',
    component: Admin,
    name: 'Device',
    meta: {
      title: 'Device',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'device-device-list',
        name: 'ADevices',
        component: Admin,
        meta: {
          title: 'Devices',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'device-document-list',
        name: 'ADocumentation Management',
        component: Document,
        meta: {
          title: 'Documentation Management',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'device-history-list',
        name: 'Histories',
        component: AdminHistory,
        meta: {
          title: 'Histories',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'equipment-usage',
        name: 'Statistics',
        component: AdminTroubleshootingStatitics,
        meta: {
          title: 'Statistics',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      }
    ],
  },
  {
    path: '/administration',
    component: Admin,
    name: 'Maintenance',
    meta: {
      title: 'Maintenance',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
    children: [
      {
        path: 'product-maintenance-manage',
        name: 'Preventive maintenance',
        component: AdminMaintenanceSetting,
        meta: {
          title: 'Preventive maintenance',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      },
      {
        path: 'maintenance-link-product',
        name: 'Manage maintenance products',
        component: AdminMaintenanceProduct,
        meta: {
          title: 'Manage maintenance products',
          icon: CursorClickIcon,
          color: 'text-danger-50',
          requiresAuth: true,
        },
      }
    ],
  },
  {
    path: '/device/error-report/:id/detail',
    component: ErrorReport,
    name: 'Error-report',
    meta: {
      title: 'Error-report',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/device-document',
    component: Document,
    name: 'Document',
    meta: {
      title: 'Document',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/dashboard/:id/detail',
    component: Device_details,
    name: 'Device-details',
    meta: {
      title: 'Device-details',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/report',
    component: ReportMessage,
    name: 'Report-message',
    meta: {
      title: 'Report-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/message/:id/machine-message',
    component: MachineMessage,
    name: 'Machine-message',
    meta: {
      title: 'Machine-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/error-report',
    component: LastFieldReportMessage,
    name: 'LastFieldReport-message',
    meta: {
      title: 'LastFieldReport-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/services-message',
    component: ServicesMessage,
    name: 'Services-message',
    meta: {
      title: 'Services-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/product/:id/details',
    component: ProductDetails,
    name: 'Product-details',
    meta: {
      title: 'Product-details',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/administration/product/:id/product-firmware',
    component: ProductFirmware,
    name: 'Product-firmware',
    meta: {
      title: 'Product-firmware',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/profile/detail',
    component: ProfileDetail,
    name: 'Profile-detail',
    meta: {
      title: 'Profile-detail',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/profile/custom-settings',
    component: ProfileCustomSettings,
    name: 'Profile-custom-settings',
    meta: {
      title: 'Profile-custom-settings',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/administration/archive/:id/product-document',
    component: ProductDocument,
    name: 'Product-document',
    meta: {
      title: 'Product-document',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/errors-message',
    component: ErrorsMessage,
    name: 'Errors-message',
    meta: {
      title: 'Errors-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/errors-instant-message',
    component: ErrorsMessage,
    name: 'Errors-instant-message',
    meta: {
      title: 'Errors-instant-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  
  {
    path: '/device/:id/alerts-message',
    component: AlertsMessage,
    name: 'Alerts-message',
    meta: {
      title: 'Alerts-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device/:id/maintenance',
    component: MaintenanceMessage,
    name: 'Maintenance-message',
    meta: {
      title: 'Maintenance-message',
      icon: LocationMarkerIcon,
      color: 'text-red-410',
      requiresAuth: true,
      parentPath: 'Home'
    },
  },
  {
    path: '/device-document-public',
    component: DeviceDocumentPublic,
    name: 'Device Document',
    meta: {
      title: 'Device Documents',
      icon: CursorClickIcon,
      color: 'text-red-410',
      requiresAuth: false,
      parentPath: 'Home'
    },
  },
]

export default routes
